import { render, staticRenderFns } from "./DdfVoteList.vue?vue&type=template&id=88552208&scoped=true&"
import script from "./DdfVoteList.vue?vue&type=script&lang=js&"
export * from "./DdfVoteList.vue?vue&type=script&lang=js&"
import style0 from "./DdfVoteList.vue?vue&type=style&index=0&id=88552208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88552208",
  null
  
)

export default component.exports